import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import DialogTitleWithCloseBtn from './DialogTitleWithCloseBtn';

const DialogTitleForMutation = (props) => {

  const { t } = useTranslation();

  const { mutationType, closeFn } = props;

  return (
    <DialogTitleWithCloseBtn titleCss={mutationType}
                             title={t(`modal_title_${mutationType}`.toLowerCase())}
                             closeFn={closeFn}
    />
  );
};

export default memo(DialogTitleForMutation);
